import { LegalSection } from "@/components/legal/LegalSection";

export const CookieIntroduction = () => (
  <LegalSection id="introduction" title="Introduction">
    <p>
      This Cookie Policy explains how Cloudjet Solutions Pte. Ltd. ("Locuno,"
      "we," "us," or "our") uses cookies and similar tracking technologies when
      you visit our website and use our services.
    </p>
    <p>
      This policy should be read alongside our{" "}
      <a href="/pages/privacy" className="text-blue-600 hover:underline">
        Privacy Policy
      </a>
      , which provides additional information about how we collect, use, and
      protect your personal information.
    </p>
  </LegalSection>
);
